export default {
  name: 'MStepper',
  props: {
    data: {
      required: true,
      type: Object,
    },
    active: {
      required: true,
      type: Number,
    },
    activeChildStep: {
      required: false,
      default: 0,
      type: Number,
    },
    disableLinks: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getBGStyle() {
      return `bg-${this.data.style}-100`;
    },
    getH2Style() {
      return `text-${this.data.style}-900`;
    },
    getStepStyle() {
      return `text-${this.data.style}-900`;
    },
    currentStepHasChildren() {
      const currentStep = this.data.steps[this.active];
      return Object.prototype.hasOwnProperty.call(currentStep, 'children');
    },
  },
  methods: {
    getBorderStyle(step) {
      if (this.active >= step) {
        return `border-${this.data.style}-900`;
      }
      return `border-${this.data.style}-600`;
    },
    getBorderStyleChild(step) {
      if (this.activeChildStep >= step) {
        return `border-${this.data.style}-900`;
      }
      return `border-${this.data.style}-600`;
    },
    handleStepChange(step) {
      // eslint-disable-next-line max-len
      if (step < this.active && !this.disableLinks && !this.data.steps[step].disableStepLink) {
        this.$emit('changeStep', step);
      }
    },
  },
};
